import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

// constant
import { API_URL } from '../constant';

const SessionContext = createContext();

export function SessionProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [tagsList, setTagsList] = useState([]);

  useEffect(() => {
    if (!company || !currentUser) return;
    fetchTags();
  }, [currentUser, company]);

  const fetchTags = async () => {
    if (tagsList.length) return;

    try {
      const response = await axios.get(`${API_URL}/tags/all-tags/`);
      setTagsList(
        response.map((ele) => ({
          ...ele,
          title: `${ele.name} ${ele.code} ${ele.tag_type?.name}`,
          label: (
            <>
              {ele.name}
              {'  '}
              {ele.code && (
                <b>
                  ({ele.code}){'  '}
                </b>
              )}
              {ele.tag_type && <b>({ele.tag_type?.name})</b>}
            </>
          ),
          value: ele.id,
        })),
      );
    } catch {
      setTagsList([]);
    }
  };

  const value = {
    currentUser,
    company,
    setCurrentUser,
    setCompany,
    fetchTags,
    tagsList,
  };

  return (
    <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
  );
}

SessionProvider.propTypes = {
  children: PropTypes.node,
};

export function useSession() {
  const context = useContext(SessionContext);
  if (context === undefined) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
}
